import HolidayIcon from '@material-ui/icons/Event'; // Change the icon to something related to holidays
import AppointmentList from './AppointmentList';
export default {
    list: AppointmentList,
    icon: HolidayIcon,
};
